
import * as classNames from "classnames"
import { AddCommentFormRenderProps } from "../addCommentFormWrapper";
import { getTranslation } from "../translations";
import { disablePageRefresh, enablePageRefresh } from "../../../../../siteWidgets/siteWidgetUtils";

interface AddCommentFormProps {
    props: AddCommentFormRenderProps
}

export class AddCommentFormUI2026 extends React.Component<AddCommentFormProps, {}> {
    private getTermsLinkByLang = () => {
        const { lang, siteName } = this.props.props
        if(siteName === "calcalist") {
            return "https://z.calcalist.co.il/mvc/long/2018/OrganizationalStructure/About/Terms.html"
        }
        else{
        if (lang === "he") return "https://www.ynet.co.il/article/bkswwa3sn";
        else if (lang === "ru") return "https://www.vesty.co.il/articles/0,7340,L-4867560,00.html";
        else return "https://www.ynetnews.com/article/bkh7s3p7t"
        }
    }

    private onConfirmAlertBtnPress = () => {
        const { closeAlert, resetFormData, handleCloseCommentForm } = this.props.props
        closeAlert()
        handleCloseCommentForm()
        resetFormData()
    }

    handleInputFocus = () => {
        disablePageRefresh()
    }

    handleInputOutOfFocus = () => {
        enablePageRefresh()
    }


    render() {
        const { isAddCommentFormVisible, isSent, title, name, email, comment, showAlert, formType, shouldTitleBeHidden,
            lang, alertBeforeClosing, handleCloseCommentForm, closeAlert, onInputChanged, handleCommentSend, isFirstComment, siteName } = this.props.props
        const AddCommentFormClasses = classNames({
            "AddCommentFormUI2026": true,
            "fadeIn": isAddCommentFormVisible,
            "hide": !isAddCommentFormVisible,
        })
        let term1 = "אין לשלוח תגובות הכוללות מידע המפר את ";
        let term2 = "תנאי השימוש של ynet";
        let term3 = " לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.";
        if (lang === "en") {
            term1 = "The commenter agrees to the privacy policy of Ynet News and agrees not to submit comments that violate the ";
            term2 = "terms of use";
            term3 = ", including incitement, libel and expressions that exceed the accepted norms of freedom of speech.";
        }
        if (lang === "ru") {
            term1 = "Автор комментария принимает Условия конфиденциальности Вести и соглашается не публиковать комментарии, нарушающие ";
            term2 = "Правила использования";
            term3 = ",  в том числе подстрекательство, клевету и выходящее за рамки приемлемого в определении свободы слова.";
        }
        if(siteName === "calcalist" && lang === "he") {
            term1 = " אין לשלוח תגובות הכוללות מידע המפר את";
            term2 = "תנאי השימוש של כלכליסט  ";
            term3 = "לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.";
        }
        return (
            <div className={AddCommentFormClasses}> 
                <div className="AddCommentForm" >
                    {!isSent &&
                        <div className="AddCommentFormContainer">
                            {!isFirstComment && <button className="closeBtnWrapper" title={getTranslation(lang, "Close(Order Male)")} onClick={e => alertBeforeClosing()}></button>}
                            {!isFirstComment && !shouldTitleBeHidden && <div className="topTitleWrapper"> 
                                <span className="formTitle"> {formType === "REPLY" ? getTranslation(lang, "Add New Comment To Comment") : getTranslation(lang, "New Comment(premium)")} </span>
                            </div>}
                            <div className="termsOfService">
                                {term1}
                                 <a href={this.getTermsLinkByLang()} target="_blank" title={getTranslation(siteName==="calcalist" ? "calcalist" :lang, "terms of use")}> {term2} </a>
                                {term3}
                            </div>
                            {showAlert && <div className="commentSentMessageWrapper alertMessage">
                                <div className="alertText"><span>{`${getTranslation(lang, "Warning")}`}</span></div>
                                <div className="successfullySentText"><span>{`${getTranslation(lang, "This Action Will Delete You Comment")}`}</span></div>
                                <div className="bottomPanel">
                                    <button className="closeText" title={getTranslation(lang, "Confirm")} onClick={this.onConfirmAlertBtnPress}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                            <path d="M3.75 15C3.75 8.7875 8.7875 3.75 15 3.75C21.2125 3.75 26.25 8.7875 26.25 15C26.25 21.2125 21.2125 26.25 15 26.25C8.7875 26.25 3.75 21.2125 3.75 15Z" stroke="#00B643" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M10 15L13.75 18.75L20 12.5" stroke="#00B643" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span>{getTranslation(lang, "Confirm")}</span></button>
                                    <button className="closeText" title={getTranslation(lang, "Cancel")} onClick={e => closeAlert()}>
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                               <path d="M3.75 15C3.75 8.7875 8.7875 3.75 15 3.75C21.2125 3.75 26.25 8.7875 26.25 15C26.25 21.2125 21.2125 26.25 15 26.25C8.7875 26.25 3.75 21.2125 3.75 15Z" stroke="#D80000"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                          <path d="M10.7574 10.7573L19.2427 19.2426" stroke="#D80000" strokeWidth="1.6" strokeLinecap="round" />
                                            <path d="M19.2426 10.7573L10.7573 19.2426" stroke="#D80000" strokeWidth="1.6" strokeLinecap="round" />
                                        </svg>

                                        <span>{getTranslation(lang, "Cancel")}</span></button>
                                </div>
                            </div>}

                            <input
                                className="userDetailsInput inputStyle"
                                maxLength={20}
                                value={name}
                                name="commenterName"
                                placeholder={getTranslation(lang, "Name")}
                                onChange={(e) => onInputChanged(e, "name")}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            />

                            <textarea
                                className="comment inputStyle"
                                type="text" maxLength={4000}
                                value={comment}
                                name="commentContent"
                                resize="vertical"
                                placeholder={getTranslation(lang, "Comment Content")}
                                onChange={(e) => onInputChanged(e, "comment", true)}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            >
                            </textarea>
                            <div className="bottomPanel">
                                <div className="bottomPanelRow">
                                    <button className="sendBtn" id="addCommentSendButton" title={getTranslation(lang, "Publish Comment")} onClick={e => handleCommentSend()}>
                                        <span>{getTranslation(lang, "Publish Comment")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>}

                    {isSent && <div className="commentSentMessageWrapper">
                        <div className="thankYouWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                <path d="M3.75 15C3.75 8.7875 8.7875 3.75 15 3.75C21.2125 3.75 26.25 8.7875 26.25 15C26.25 21.2125 21.2125 26.25 15 26.25C8.7875 26.25 3.75 21.2125 3.75 15Z" stroke="#00B643" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10 15L13.75 18.75L20 12.5" stroke="#00B643" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="thankYou"><strong >{getTranslation(lang, "Thank You")},</strong> <span>{getTranslation(lang, "Comment Sent Confirmation Message")}</span></div>
                            <button className="closeTextWrapper closeIcon" title={getTranslation(lang, "Close")} onClick={this.onConfirmAlertBtnPress}>

                            </button>
                        </div>
                    </div>}
                </div>

            </div>
        )
    }
}